import { openkit } from "../../library/database";
import { TRANSPORTATION } from "./transportationConstants";

export const setFilterOptions = async (
  info,
  setTypeOptions,
  setAmenitiesOptions
) => {
  const queryTypes = {
    category: "tra_type",
    table: "c_products",
    type: "transportation",
  };

  const queryAmenities = {
    category: "tra_amenities",
    table: "c_products",
    type: "transportation",
  };

  try {
    const resp = await openkit.custom.execute("post", "get-categories", null, {
      query: queryTypes,
    });
    resp.length &&
      setTypeOptions(
        resp.map((t) => ({
          value: t.tra_type,
          label: info.t(t.tra_type),
        }))
      );

    const respAmenities = await openkit.custom.execute(
      "post",
      "get-categories",
      null,
      { query: queryAmenities }
    );
    let amenities = [];
    respAmenities.forEach(
      (a) => (amenities = [...amenities, ...a.tra_amenities])
    );

    amenities = [...new Set(amenities)];
    setAmenitiesOptions(
      amenities.map((a) => ({
        value: a,
        label: info.t(a),
      }))
    );
  } catch (error) {
    console.log(`error`, error);
  }
};
